import { isSocialChannel } from 'src/data/channel';
import { getIsEmailChannel } from 'src/data/performance';

export const MEDIAN_DAYS_OPTIONS = [90, 180];

export const getChartDateLabel = (channel) => {
  if (isSocialChannel(channel)) {
    return 'Published date';
  }
  if (getIsEmailChannel(channel)) {
    return 'Send date';
  }

  return 'First impressions date';
};

export const getChartValueLabel = (channel) => {
  if (isSocialChannel(channel)) {
    return 'Reach';
  }
  if (getIsEmailChannel(channel)) {
    return 'Delivered';
  }

  return 'Impressions';
};
